import React, { useContext } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { P } from '@components/shared/Typography';
import { getSupplyChainPricing } from '@utils/supplyChain';
import Modal from './Modal';

interface IProps {
  isOpen: boolean;
  closeModal: () => void;
  style?: Object;
}

const PricingModal: React.FC<IProps> = ({ isOpen, closeModal, style }) => {
  const { t } = useTranslation();
  const { state } = useContext(Context);
  const { currency } = state;
  const supplyChainPricing = getSupplyChainPricing();

  const children = (
    <div>
      <MemberText $mods={['center']}>{t('components.landing-science.chain-costs')}</MemberText>
      <PriceTable>
        <TableHeader>{t('components.landing-science.naked')}</TableHeader>
        <TableRow>
          <PriceName>{t('components.landing-science.tampons')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.tampons[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.sanitisation')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.sanitisation[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.testing')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.testing[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.packaging')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.packaging[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.cargo')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.cargo[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableDivide />
        <TableRow>
          <PriceName>{t('components.landing-science.true-cost')}*</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.trueCostNaked[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRowBold>
          <PriceName>{t('components.landing-science.our-price')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.consumerNaked[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRowBold>
      </PriceTable>

      <PriceTable>
        <TableHeader>{t('components.landing-science.cramp')}</TableHeader>
        <TableRow>
          <PriceName>{t('components.landing-science.tampons')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.tampons[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.sanitisation')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.sanitisation[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.cramp-extract')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.cbd[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.testing')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.testing[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.packaging')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.packaging[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRow>
          <PriceName>{t('components.landing-science.cargo')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.cargo[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableDivide />
        <TableRow>
          <PriceName>{t('components.landing-science.true-cost')}*</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.trueCostCBD[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRow>
        <TableRowBold>
          <PriceName>{t('components.landing-science.our-price')}</PriceName>
          <PriceTotal>
            {currency.symbol}
            {supplyChainPricing.consumerCBD[currency.letterCode]?.toFixed(2)}
          </PriceTotal>
        </TableRowBold>
      </PriceTable>
      <ModalEndClose>
        <LinkStyled onClick={closeModal}>{t('components.close')}</LinkStyled>
      </ModalEndClose>
    </div>
  );

  return (
    <Modal title={t('components.landing-science.pricing')} modalOpen={isOpen} onClose={closeModal} stickyHeader={true}>
      {children}
    </Modal>
  );
};

export default PricingModal;

const PStyled = styled(P)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0;
  margin-bottom: 30px;
`;

const LinkStyled = styled.a`
  font-family: 'BrownStd';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  border-bottom: 2px solid #003b1b;
  margin-bottom: 20px;
  display: inline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    opacity: 0.5;
  }
`;

const MemberText = styled(PStyled)`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  color: #003b1b;
`;

const ModalEndClose = styled.div`
  text-align: center;
`;

const PriceTable = styled.div`
  border-bottom: 1px solid #f9d07c;
  margin-bottom: 40px;
  padding-bottom: 10px;
`;

const TableHeader = styled.div`
  font-family: 'BrownStd';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 1.5px;
  text-align: center;
  text-transform: uppercase;
  border-bottom: 1px solid #f9d07c;
  padding: 30px;
  color: #003b1b;
  margin-bottom: 10px;
`;

const TableRow = styled.div`
  padding: 12px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TableRowBold = styled(TableRow)`
  font-weight: bold;
`;

const TableDivide = styled.div`
  width: 100%;
  height: 1px;
  background: #f9d07c;
  margin: 10px 0;
`;

const PriceName = styled(P)`
  font-family: 'BrownStd';
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
`;

const PriceTotal = styled(P)`
  font-family: 'BrownStd';
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  text-align: right;
`;
